import { push } from 'connected-react-router'
import { deliveryClient, ws } from 'shared/store/ws'
import { preventPersistedError } from 'shared/store/user/actions'

const authMiddleware = (store: any) => (next: any) => (action: any) => {
    const { getState } = store
    const { messages } = getState().i18nState
    const { userState } = getState()
    const { token, error } = userState
    const wsHeaders = ws.defaults.headers
    const deliveryHeaders = deliveryClient.defaults.headers
    switch (action.type) {
        case 'SIGNIN_WITH_TOUCH_ID':
        case 'UPDATE_TOKEN':
            if (error?.request?.status === 401) {
                store.dispatch(preventPersistedError())
            }
            if (token !== undefined) {
                wsHeaders['Authorization'] = action.token
                deliveryHeaders['Authorization'] = action.token
            }
            break
        case 'SIGNIN_SEND_FORM_SUCCESS':
            wsHeaders['Authorization'] = action.token
            deliveryHeaders['Authorization'] = action.token
            break
        case 'PROFILE_DELETE_SUCCESS':
        case 'LOGOUT_DONE':
            wsHeaders['Authorization'] = undefined
            deliveryHeaders['Authorization'] = undefined
            break
        case 'PAGE_API_AUTH_ERROR':
            wsHeaders['Authorization'] = undefined
            deliveryHeaders['Authorization'] = undefined
            store.dispatch(push(messages['routes.signin']))
            break
        case '@@router/LOCATION_CHANGE':
            const { pathname, search } = action.payload.location
            if (token) {
                if (
                    pathname === messages['routes.signin'] ||
                    pathname === messages['routes.signup']
                ) {
                    //If the user is authenticated and tries to access the signin or signup page, redirect to the dashboard,
                    // unless there is a fromUrl parameter in the URL, which would probably come from the order flow
                    const searchParams = new URLSearchParams(search)
                    const fromUrl = searchParams.get('fromUrl')
                    if (fromUrl && !fromUrl.startsWith('http')) {
                        store.dispatch(push(searchParams.get('fromUrl')))
                    } else {
                        store.dispatch(
                            push(messages['routes.kingdom.dashboard'])
                        )
                    }
                    return
                }
            }

            break
        default:
            return next(action)
    }
    return next(action)
}

export { authMiddleware }
